export const SITE_TITLE = 'todayilearned';
